import React, { useEffect, useState } from 'react';
import {csCZ} from "@mui/x-data-grid/locales";
import {DataGridPro} from "@mui/x-data-grid-pro";
import { invoicesColumns} from "../../../data/DatatableColumns";
import {CustomSearchBar, useFilteredColumns} from "../../CustomSearchBar";

const Invoices = ({ company, selectedContract }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (company) {
      const filteredRows = company.receivedInvoiceList
        .filter((invoice) => invoice.contract === selectedContract.code)
        .flatMap((invoice, invoiceIndex) =>
          invoice.paymentList.map((payment, paymentIndex) => ({
            id: `${invoiceIndex}-${paymentIndex}`, // Unique ID for each row
            code: invoice.code,
            company: invoice.company,
            description: invoice.description,
            statusPaid: invoice.statusPaid,
            amountBase: invoice.amountBase,
            amountVat: invoice.amountVat,
            amountTotal: invoice.amountTotal,
            paymentAmount: payment.paymentAmount,
            expoDate: invoice.expoDate,
            dueDate: invoice.dueDate,
            paymentDate: payment.paymentDate,
          }))
        );
      setRows(filteredRows);
    }
  }, [company, selectedContract]);

  const columns = useFilteredColumns(() => invoicesColumns());


  return (
      <DataGridPro
        columns={columns}
        rows={rows}
        hideFooter
        fullWidth
        localeText={csCZ.components.MuiDataGrid.defaultProps.localeText}
        getCellClassName={(params) => {
          if (params.value < 0) {
            return 'negative'
          }
        }}
        slots={{ toolbar: CustomSearchBar }}
        sx={{
          height: "68vh",
          width: "100%",
          borderTop: "none",
          '&.MuiDataGrid-root': {
            borderRadius: '0px',
            borderLeft: 'none',
            borderRight: 'none',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold', overflow: 'visible'
          },
          '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#f8f8f8',
          },
          '& .negative': {
            color: 'red'
          },
        }}/>
  );
};

export default Invoices;